// /me — "Minha conta" (Parte 3.8, GIY-037): perfil mínimo, segundo fator, sessões ativas com revogação (step-up) e troca
// de senha; acessível mesmo sem contexto (pouso `/no-access`). Atalhos para a inbox e as preferências (M1).
import { PageHeader } from '@giyus/patterns';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { MfaCard, ProfileCard } from '../modules/identity/account/AccountCards';
import { ChangePasswordForm } from '../modules/identity/account/ChangePasswordForm';
import { SessionsCard } from '../modules/identity/account/SessionsCard';

export function AccountMeNav() {
  const { t } = useTranslation('identity');
  const tabClass = ({ isActive }: { readonly isActive: boolean }) =>
    isActive ? 'giyus-tab-btn giyus-tab-btn-active font-semibold' : 'giyus-tab-btn';

  return (
    <nav aria-label={t('account.links.title')} className="giyus-tabs" data-testid="me-account-subnav">
      <NavLink className={tabClass} to="/me" end data-testid="link-my-account">
        {t('account.title')}
      </NavLink>
      <NavLink className={tabClass} to="/me/person" data-testid="link-my-registration">
        {t('account.links.person')}
      </NavLink>
      <NavLink className={tabClass} to="/me/inbox">
        {t('account.links.inbox')}
      </NavLink>
      <NavLink className={tabClass} to="/me/preferences/notifications">
        {t('account.links.preferences')}
      </NavLink>
      <NavLink className={tabClass} to="/me/access-reviews" data-testid="link-access-reviews">
        {t('account.links.accessReviews')}
      </NavLink>
      <NavLink className={tabClass} to="/me/two-key" data-testid="link-two-key">
        {t('account.links.twoKey')}
      </NavLink>
      <NavLink className={tabClass} to="/me/delegations" data-testid="link-my-delegations">
        {t('account.links.delegations')}
      </NavLink>
    </nav>
  );
}

export function AccountPage() {
  const { t } = useTranslation('identity');
  return (
    <section className="mx-auto flex max-w-2xl flex-col gap-5" data-testid="account">
      <PageHeader
        eyebrow="Minha conta"
        title={t('account.title')}
        description={t('account.subtitle')}
      />
      <AccountMeNav />
      <ProfileCard />
      <MfaCard />
      <SessionsCard />
      <ChangePasswordForm />
    </section>
  );
}
